import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-[13px] ml-[6px] text-left text-[24px] font-bold leading-[160%] tracking-[-0.035em] text-white" }, " 아바타 선택 ", -1)
const _hoisted_2 = { class: "mb-[19px] grid grid-cols-4 gap-5" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "text-center text-[14px] font-medium leading-[136%] tracking-[-0.015em] text-white" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mb-[13px] ml-[6px] text-left text-[24px] font-bold leading-[160%] tracking-[-0.035em] text-white" }, " 제스처 선택 ", -1)
const _hoisted_6 = {
  key: 0,
  class: "grid grid-cols-5 gap-5"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "text-center text-[14px] font-medium leading-[136%] tracking-[-0.015em] text-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cloneList, (avatar, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `avatar-${idx}`,
          class: _normalizeClass(["w-full transition-all", [{ 'opacity-60': _ctx.selected.avatar !== idx }]])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["mb-2 h-[126px] cursor-pointer overflow-hidden rounded-[12px] border-[3px] border-solid bg-cover bg-center bg-no-repeat bg-origin-border transition-all", [_ctx.selected.avatar === idx ? 'border-[#6150FF]' : 'border-transparent']]),
            style: _normalizeStyle({
          backgroundImage: `url(https://klleon-media.s3.ap-northeast-2.amazonaws.com/media/public/deephuman__aiv_admin/image/720/${avatar.motions[0].faceToken}.jpg)`,
        }),
            onClick: ($event: any) => (_ctx.handleSelectAvatar(idx))
          }, null, 14, _hoisted_3),
          _createElementVNode("div", _hoisted_4, _toDisplayString(avatar.name), 1)
        ], 2))
      }), 128))
    ]),
    _hoisted_5,
    (_ctx.cloneList.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cloneList[_ctx.selected.avatar].motions, (gesture, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `gesture-${idx}`,
              class: _normalizeClass(["w-full transition-all", [{ 'opacity-60': _ctx.selected.gesture !== idx }]])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["mb-2 h-[126px] cursor-pointer overflow-hidden rounded-[12px] border-[3px] border-solid bg-cover bg-center bg-no-repeat bg-origin-border transition-all", [_ctx.selected.gesture === idx ? 'border-[#6150FF]' : 'border-transparent']]),
                style: _normalizeStyle({
          backgroundImage: `url(https://klleon-media.s3.ap-northeast-2.amazonaws.com/media/public/deephuman__aiv_admin/image/720/${gesture.videoToken}.jpg)`,
        }),
                onClick: ($event: any) => (_ctx.handleSelectGesture(idx))
              }, null, 14, _hoisted_7),
              _createElementVNode("div", _hoisted_8, _toDisplayString(gesture.desc), 1)
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}